import React from "react";
import { PageLayout } from "../components/PageLayout";
import ct1 from '../images/customtours/1.jpg';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import ContactCTA from "../components/ContactCTA";

const CustomGroupTours = () => {
  document.title = "Custom Group Tours - Hampton Jitney Charters";
  return (
    <PageLayout>
      <div className="flex-grow overflow-y-scroll">
        <div className="border border-black rounded-lg p-4 mt-4 bg-white bg-opacity-75 mx-4">
          <h1 className="text-4xl font-bold mb-4 text-center">Custom Group Tours</h1>
          <div className="w-full lg:w-1/2">
            <p class="text-2xl text-gray-800 mb-8">
              Hampton Jitney specializes in providing exceptional private group tours tailored 
              to your specific needs and preferences. 
            </p>
            <p class="text-lg font-semibold text-gray-800 mb-8">
              Whether you're planning a sightseeing adventure, a winery tour, or a cultural exploration, 
              our experienced team will work closely with you to create a customized itinerary that 
              captures the essence of your desired destination. With our fleet of comfortable and 
              well-maintained vehicles, professional drivers, and attention to detail, we ensure a 
              seamless and enjoyable tour experience. Sit back, relax, and let Hampton Jitney take care 
              of all the logistics while you and your group create unforgettable memories. 
            </p>
            <p class="text-xl font-bold text-gray-800 mb-8">
            Choose Hampton Jitney for private group tours that exceed your expectations.
            </p>
            <ContactCTA
              heroImg={ct1}
              ctaText={"Contact us today to assemble your Custom Group Tour"}
              bodyText={"Contact us at 631-287-4000, or <a href='mailto:charter@hamptonjitney.com'>charter@hamptonjitney.com</a>."}
            />
          </div>
          <Carousel
            className="flex justify-between w-[60%] mt-4 mx-auto mt-20"
            showArrows={true}
            infiniteLoop={true}
            showThumbs={false}
            showStatus={false}

          >
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={ct1} alt="ig1" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

          </Carousel>
        </div>
      </div>
    </PageLayout>
  );
};

export default CustomGroupTours;
